import { useState, useEffect } from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { Loading } from '../loading';
import { PillButtons, Input, Button } from '../input';
import { Modal } from '../modal';
import { styles, colors, includeContentOptions } from '../../constants';
import { Timer } from './Timer';

const Result = ({ type, content, link }) => {
  const [content_, setContent_] = useState('');
  const [loading, setLoading] = useState();

  useEffect(() => {
    if (!link) {
      return;
    }
    if (content) {
      setContent_(content);
      return;
    }

    setLoading(true);

    console.log('Fetching:', link);

    fetch(link)
      .then((resp) => resp.text())
      .then((text) => {
        setLoading(false);
        setContent_(text);
      });
  }, [content, link]);

  let rendered;
  if (content?.join && ['urls', 'images'].includes(type)) {
    rendered = content.join('\n');
  } else if (typeof content == 'string') {
    rendered = content;
  } else {
    rendered = JSON.stringify(content, null, 2);
  }

  const maxHeight = 400;
  const borderRadius = 5;
  const pre = (content, style = {}) => (
    <pre
      style={{
        padding: 10,
        border: '1px solid #e3e3e3',
        background: '#f6f6f6',
        opacity: loading ? 0.5 : 1,
        borderRadius,
        maxHeight,
        ...style,
      }}
    >
      {content?.join && ['urls', 'images'].includes(type) ? content.join('\n') : content}
    </pre>
  );

  const maxWidth = 880;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
      <div style={{ position: 'relative', maxWidth }}>
        {pre(content_, { overflow: 'scroll', maxWidth })}
        <div
          style={{
            fontSize: 12,
            position: 'absolute',
            right: 2,
            top: 2,
            background: '#f6f6f6',
            borderRadius,
            padding: 8,
          }}
        >
          <a href={link} target="_blank">
            <FaExternalLinkAlt />
          </a>
        </div>
      </div>
    </div>
  );
};

const SingleVisitResult = ({ results }) => {
  const [tab, setTab] = useState();
  const [choices, setChoices] = useState([]);

  useEffect(() => {
    const val = Object.keys(results)
      .filter((key) => results[key].body)
      .sort((a, b) => a.localeCompare(b))
      .map((key) => [key]);
    setChoices(val);
  }, [results]);

  useEffect(() => {
    if (tab || !choices.length) {
      return;
    }
    setTab(choices[0][0]);
  }, [tab, choices]);

  if (!results) {
    return null;
  }

  // console.log('render results', results);

  const node = tab && results && <Result type={tab} content={results[tab].body} link={results[tab].link} />;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <PillButtons value={tab} onChange={setTab} choices={choices} />
      {node}

      <pre>{JSON.stringify(results, null, 2)}</pre>
    </div>
  );
};

const MultiVisitResult = ({ job }) => {
  const [index, setIndex] = useState(0);

  const urls = job.results.map((it) => it.url);

  const width = 360;

  const buttons = urls.map((url, idx) => {
    const active = index == idx;
    const style = {
      fontSize: 12,
      color: '#555',
      cursor: 'pointer',
      padding: '4px 8px',
      borderRadius: 5,
      width,
      ...styles.textOverflowStyle,
    };
    if (active) {
      style.color = 'black';
      style.fontWeight = 'bold';
    }
    return (
      <div key={idx} style={style} onClick={() => setIndex(idx)}>
        {url}
      </div>
    );
  });

  return (
    <div style={{ display: 'flex', gap: 20 }}>
      <div style={{ display: 'flex', flexDirection: 'column', borderRadius: 5, width, ...styles.textOverflowStyle }}>
        {buttons}
      </div>
      <div style={{ overflowX: 'hidden', width: '100%' }}>
        <SingleVisitResult results={job.results[index]} timer={job.timer} />
      </div>
    </div>
  );
};

const SingleResult = ({ result }) => {
  const choices = Object.keys(result)
    .filter((key) => result[key].body)
    .sort((a, b) => a.localeCompare(b))
    .map((key) => [key]);

  console.log('single result', result);
  console.log('single result choices', choices);

  const [tab, setTab] = useState(choices?.[0]?.[0]);

  const node = tab && <Result type={tab} content={result[tab].body} link={result[tab].link} />;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div style={styles.smallHeader}>{result.url}</div>
      <PillButtons size="sm" value={tab} onChange={setTab} choices={choices} />
      {node}
      {/*
      <pre>{JSON.stringify(result, null, 2)}</pre>
      */}
    </div>
  );
};

export const VisitResults = ({ job }) => {
  const [tab, setTab] = useState();
  const [choices, setChoices] = useState([]);
  const results = job.results;
  const nodes = (results || []).map((it) => <SingleResult result={it} />);

  return (
    <div>
      {nodes}
      {/*
      <pre>{JSON.stringify(job, null, 2)}</pre>
          <PillButtons value={tab} onChange={setTab} choices={choices} />
          {node}
      */}
    </div>
  );
};
